const firebaseConfig = {
  apiKey: "AIzaSyCEmxR7MPlcbZaJWvvjTqbSABudNWDrSyo",
  authDomain: "vinbird-nk.firebaseapp.com",
  projectId: "vinbird-nk",
  storageBucket: "vinbird-nk.appspot.com",
  messagingSenderId: "66851568361",
  appId: "1:66851568361:web:fabf9a3899f824077ace78",
  measurementId: "G-11T65KF80X"
};

export default firebaseConfig;
